module.exports = __webpack_public_path__ + "img/square-down-left.640af819.svg";